// core
import React from 'react';
import { Link } from 'react-router-dom';

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// components
import RecipientListPanel from 'components/shared/RecipientListPanel'
class Layout extends React.Component {
  handleLogoutClick() {
    Auth.setToken('');

    window.location.reload();
  }

  render() {
    var buttonStyle = {
      padding: '0 1.25rem',
      fontSize: '1rem',
      lineHeight: '3.5rem',
      verticalAlign: 'middle !important',
      outline: 'none !important'
    };

    let iconStyle = {
      marginRight: '0.25rem'
    };

    var buttons = [];

    // main
    buttons.push(
      <Link to="/" className={'btn ' + (window.location.pathname == '/' ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
        <img src="https://www.progettieducativi.it/wp-content/uploads/sites/3/2017/05/logo-w-220.png" style={{width: '110px'}} rel="noreferrer" />
      </Link>
    );

    // projects
    switch (this.props.user.type) {
      case Settings.AUTH_USER_TYPE_ADMIN:
      case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
        buttons.push(
          <Link to="/" className={'btn ' + (window.location.pathname.indexOf('/projects') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            Progetti
          </Link>
        );
        break;
    }

    // products
    switch (this.props.user.type) {
      case Settings.AUTH_USER_TYPE_ADMIN:
      case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
        buttons.push(
          <Link to="/products/overview/" className={'btn ' + (window.location.pathname.indexOf('/products') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            Progetti
          </Link>
        );
        break;
      case Settings.AUTH_USER_TYPE_EDU:
      case Settings.AUTH_USER_TYPE_MARKETING:
        buttons.push(
          <Link to="/kits/overview/" className={'btn ' + (window.location.pathname.indexOf('/kits') == 0 || window.location.pathname.indexOf('/kit-orders') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            <i style={iconStyle} className="fa fa-gift" /> Kit + ordini
          </Link>
        );
        break;
    }

    // orders
    switch (this.props.user.type) {
      case Settings.AUTH_USER_TYPE_ADMIN:
      case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
        buttons.push(
          <Link to="/orders/overview/" className={'btn ' + (window.location.pathname.indexOf('/orders') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            Ordini
          </Link>
        );
        break;
      case Settings.AUTH_USER_TYPE_EDU:
        break;
      case Settings.AUTH_USER_TYPE_MARKETING:
        break;
    }

    // schools
    switch (this.props.user.type) {
      case Settings.AUTH_USER_TYPE_ADMIN:
      case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
        break;
      case Settings.AUTH_USER_TYPE_EDU:
      case Settings.AUTH_USER_TYPE_MARKETING:
        buttons.push(
          <Link to="/schools/overview/" className={'btn ' + (window.location.pathname.indexOf('/schools') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            <i style={iconStyle} className="fa fa-school" /> Scuole
          </Link>
        );
        break;
    }

    // // principals
    // switch (this.props.user.type) {
    //   case Settings.AUTH_USER_TYPE_ADMIN:
    //   case Settings.AUTH_USER_TYPE_EDU:
    //   case Settings.AUTH_USER_TYPE_MARKETING:
    //     buttons.push(
    //       <Link to="/principals/overview/" className={'btn ' + (window.location.pathname.indexOf('/principals') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
    //         <i style={iconStyle} className="fa fa-user-tie" /> Dir. scolastici
    //       </Link>
    //     );
    //     break;
    //   case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
    //       break;
    // }

    // teachers
    switch (this.props.user.type) {
      case Settings.AUTH_USER_TYPE_ADMIN:
      case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
        break;
      case Settings.AUTH_USER_TYPE_EDU:
      case Settings.AUTH_USER_TYPE_MARKETING:
        buttons.push(
          <Link to="/teachers/overview/" className={'btn ' + (window.location.pathname.indexOf('/teachers') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            <i style={iconStyle} className="fa fa-chalkboard-teacher" /> Insegnanti
          </Link>
        );
        break;
    }

    // families
    switch (this.props.user.type) {
      case Settings.AUTH_USER_TYPE_ADMIN:
      case Settings.AUTH_USER_TYPE_PROJECT_MANAGER:
        break;
      case Settings.AUTH_USER_TYPE_EDU:
      case Settings.AUTH_USER_TYPE_MARKETING:
        buttons.push(
          <Link to="/families/" className={'btn ' + (window.location.pathname.indexOf('/families') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
            <i style={iconStyle} className="fa fa-users" /> Famiglie
          </Link>
        );
        break;
    }

    // marketing
    buttons.push(
      <Link to="/marketing/mailings/overview/" className={'btn ' + (window.location.pathname.indexOf('/marketing/mailings') == 0 ? 'btn-primary' : 'btn-secondary') + ' align-middle'} style={buttonStyle}>
        <i style={iconStyle} className="fa fa-mail-bulk" /> Mailing
      </Link>
    );

    return (
      <div>
        <header className="mb-4">
          <div className="container">
            <div className="row">
              <div className="col-9">
                <div className="btn-group my-2">
                  {buttons}
                </div>
              </div>
              <div className="col-3 my-2 text-right">
                <button className="btn btn-secondary align-middle mt-2" onClick={this.handleLogoutClick}>
                  <i className="fa fa-sign-out" /> esci
                </button>
              </div>
            </div>
          </div>
        </header>

        {this.props.children}

        <footer className="mt-4 mb-0" style={{backgroundColor: '#fff', borderTop: '2px solid #ddd'}}>
          <div className="container">
            <div className="row">
              <div className="col-6">
                <p className="px-0 py-4 m-0">Dashboard v.2.3<br />
                API v1 (90%) &middot; API v2 (10%)</p>
              </div>
              <div className="col-6">
                <p className="text-right">
                  <img style={{opacity: 0.5}} className="mt-4" width="50px" src="https://i.imgsonic.com/example/?src=https://i1.wp.com/farm4.static.flickr.com/3188/3084710361_bdba181ac3_d.jpg&crop=1&crop_width=140&crop_height=100" />
                </p>
              </div>
            </div>
          </div>
        </footer>

        <RecipientListPanel
          schools={this.props.appData.mailings.mailingPanelList.schoolsById}
          teachers={this.props.appData.mailings.mailingPanelList.teachersById}
          onRemoveAllRecipients={this.props.onRemoveAllRecipients}
        />
      </div>
    );
  }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/pages/shared/Layout.js